
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 513 342"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#095FAD","d":"M0 0h513v342H0z"}}),_c('g',{attrs:{"fill":"#BE1229"}},[_c('path',{attrs:{"d":"M342 0h171v342H342zM0 0h171v342H0z"}})]),_c('g',{attrs:{"fill":"#FFDA44"}},[_c('path',{attrs:{"d":"M108.3 166.3h14.8v74.2h-14.8zM48.9 166.3h14.8v74.2H48.9z"}}),_c('circle',{attrs:{"cx":"86","cy":"203.4","r":"14.8"}}),_c('path',{attrs:{"d":"M71.2 225.7h29.7v14.8H71.2zM71.2 166.3h29.7v14.8H71.2z"}}),_c('circle',{attrs:{"cx":"86","cy":"144","r":"14.8"}}),_c('path',{attrs:{"d":"M76.3 123.9h19.5L86 108.3z"}})])])
          )
        }
      }
    